import { getWindowSafe } from '@change-corgi/core/window';

export function useMobileNativeShareAvailable(): boolean {
	const window = getWindowSafe();

	return !!window?.navigator.canShare;
}
